import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const Unsubscribe = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "unsubscribe" */ './hocs')),
});
